module.exports = __webpack_public_path__ + "static/media/basis-grotesque-mono-medium.0a0fdca3.ttf";